import React from 'react';
import type { Theme } from '@material-ui/core/styles';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/styles';
import { colors, typography } from '@skyslope/mache';
import cs from 'classnames';

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    width: '100%',
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
  },
  input: {
    fontFamily:
      'proxima-nova,Montserrat,-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,Roboto,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
    flexGrow: 1,
    borderRadius: '26px',
    border: `1px solid ${colors.grey[400]}`,
    padding: theme.spacing(1, 2),
    '&:focus': {
      outline: 'none',
    },
    '&::placeholder': {
      color: colors.grey[500],
    },
    ...(typography.body1 as any),
  },
  icon: {
    color: colors.grey[500],
    position: 'absolute',
    right: theme.spacing(3),
    pointerEvents: 'none',
  },
  clearIcon: {
    color: colors.grey[800],
    pointerEvents: 'initial',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

interface SearchProps extends Omit<React.ComponentProps<'div'>, 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  title?: string;
}

function Search(props: SearchProps) {
  const classes = useStyles(props);
  const { className, value, onChange, disabled, title, ...rest } = props;

  return (
    <div {...rest} className={cs(classes.wrapper, className)}>
      <input
        title={title}
        disabled={disabled}
        placeholder="Search..."
        className={classes.input}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-spec="search-input"
      />

      {value ? (
        <ClearIcon
          className={`${classes.icon} ${classes.clearIcon}`}
          onClick={disabled ? undefined : () => onChange('')}
        />
      ) : (
        <SearchIcon className={classes.icon} />
      )}
    </div>
  );
}

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default Search;
